import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import DefaultLayout from './layouts/DefaultLayout';
import ScrollTop from './components/ScrollTop';
import Home from './screens/Home';
import DoctorProfile from './screens/DoctorProfile';
import DoctorScreen from './screens/DoctorScreen';
import AboutUs from './screens/AboutUs';
import Contact from './screens/Contact';
import NotFound from './components/NotFound';
import Prices from './screens/Prices';


function App() {

  return (
    <BrowserRouter>
      <ScrollTop/>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route index element={<Home />} />
          <Route path="/doctors/:category" element={<DoctorProfile />} />
          <Route path="/doctor/:doctorId" element={<DoctorScreen />} />
          <Route path={'about-us'} element={ <AboutUs/> } />
          <Route path={'contact'} element={ <Contact/> } />
          <Route path={'prices'} element={ <Prices/> } />
          <Route path={'*'} element={<NotFound/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
